import { defineMessages, IntlShape } from "react-intl";

import RecordSummaryPeriod from "@mapmycustomers/shared/enum/fieldAgent/RecordSummaryPeriod";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages<RecordSummaryPeriod>({
  [RecordSummaryPeriod.LAST_12_MONTHS]: {
    id: "recordPane.fieldAgent.brief.timeframeLast12Months",
    defaultMessage: "Last 12 months",
    description:
      "Option in the record summary's timeframe list: the summary covers the last 12 months",
  },
  [RecordSummaryPeriod.LAST_3_MONTHS]: {
    id: "recordPane.fieldAgent.brief.timeframeLast3Months",
    defaultMessage: "Last 3 months",
    description:
      "Option in the record summary's timeframe list: the summary covers the last 3 months",
  },
  [RecordSummaryPeriod.LAST_30_DAYS]: {
    id: "recordPane.fieldAgent.brief.timeframeLast30Days",
    defaultMessage: "Last 30 days",
    description:
      "Option in the record summary's timeframe list: the summary covers the last 30 days",
  },
  [RecordSummaryPeriod.LAST_6_MONTHS]: {
    id: "recordPane.fieldAgent.brief.timeframeLast6Months",
    defaultMessage: "Last 6 months",
    description:
      "Option in the record summary's timeframe list: the summary covers the last 6 months",
  },
});

const getRecordSummaryPeriodDisplayName = (intl: IntlShape, period: RecordSummaryPeriod) =>
  getDisplayName(intl, messages, period, "RecordSummaryPeriod");

export default getRecordSummaryPeriodDisplayName;
